import React from "react";
import MarketplaceListCard from "../../shared/MarketplaceListCard";
import PrimaryActionLink from "../../shared/PrimaryActionLink";
import StatusBadge from "../../shared/StatusBadge";
import UserService from "../../../services/UserService";
import { formatDateTime } from "../../../utils/date";
import {
  getRichiestaExpiresAt,
  hasStartedProcess,
  isRichiestaExpired,
} from "../../../utils/richiestaExpiry";

const getRequestDisplayTitle = (richiesta) => {
  const title = (richiesta?.titolo || "").trim();
  if (title && !/^Richiesta farmaci/i.test(title)) {
    return title;
  }

  const prodotti = Array.isArray(richiesta?.prodotti) ? richiesta.prodotti : [];
  if (prodotti.length === 0) {
    return title || "Ordine marketplace";
  }

  const firstName = prodotti[0]?.nome || "Prodotto";
  return prodotti.length === 1
    ? `Ordine ${firstName}`
    : `Ordine ${firstName} +${prodotti.length - 1}`;
};
const SellerRequestCard = ({ richiesta }) => {
  const parsed = UserService.getParsedToken() || {};
  const currentSellerId = parsed.preferred_username || parsed.email || parsed.sub || "";
  const prodottiCount = richiesta.prodotti?.length || 0;
  const modalita = richiesta.criteriInvio?.modalita || "N/D";
  const sellerAssignment = (richiesta.sellers || []).find((item) => item.sellerUserId === currentSellerId);
  const sellerStatus = sellerAssignment?.status || "DA_RISPONDERE";
  const acceptedOfferId = richiesta.offertaAccettataId || null;
  const sellerOffer = (richiesta.offerte || []).find((item) => item.sellerId === currentSellerId) || null;
  const isAcceptedForSeller = Boolean(acceptedOfferId) && [sellerOffer?.id, currentSellerId].includes(acceptedOfferId);
  const paymentState = richiesta.pagamento?.stato || "NON_AVVIATO";
  const isPaymentPending = paymentState === "IN_ATTESA";
  const isPaid = paymentState === "PAGATO";
  const isAwaitingPaymentSelection = richiesta.stato === "IN_ATTESA_PAGAMENTO" && !isPaymentPending && !isPaid;
  const requestPath = `${process.env.PUBLIC_URL}/seller-richieste/${richiesta.id || richiesta._id}`;
  const isExpired = isRichiestaExpired(richiesta);
  const processStarted = hasStartedProcess(richiesta);
  const expiresAt = getRichiestaExpiresAt(richiesta);
  const expiryMetaText =
    !processStarted && expiresAt
      ? `${isExpired ? "Scaduta" : "Scade"} il ${formatDateTime(expiresAt.toISOString())}`
      : "";

  const isAssignedToAnotherSeller = Boolean(acceptedOfferId) && !isAcceptedForSeller;

  let sellerBadgeClass = "is-pending";
  let sellerBadgeTone = "warning";
  let sellerBadgeText = sellerStatus === "OFFERTA_INVIATA" ? "Offerta inviata" : "Da rispondere";

  if (isExpired) {
    sellerBadgeClass = "is-assigned";
    sellerBadgeTone = "danger";
    sellerBadgeText = "Richiesta scaduta";
  } else if (isAssignedToAnotherSeller) {
    sellerBadgeClass = "is-assigned";
    sellerBadgeTone = "danger";
    sellerBadgeText = isAwaitingPaymentSelection ? "Offerta non selezionata" : "Ordine assegnato altrove";
  } else if (isAcceptedForSeller && !isPaymentPending && !isPaid && richiesta.stato !== "IN_LAVORAZIONE") {
    sellerBadgeClass = "is-checkout";
    sellerBadgeTone = "warning";
    sellerBadgeText = "In attesa di pagamento";
  } else if (richiesta.stato === "IN_LAVORAZIONE" && isAcceptedForSeller) {
    sellerBadgeClass = "is-paid";
    sellerBadgeTone = "success";
    sellerBadgeText = "In lavorazione";
  } else if (paymentState === "PAGATO" && isAcceptedForSeller) {
    sellerBadgeClass = "is-paid";
    sellerBadgeTone = "success";
    sellerBadgeText = "Pagata";
  } else if (paymentState === "IN_ATTESA" && isAcceptedForSeller) {
    sellerBadgeClass = "is-checkout";
    sellerBadgeTone = "warning";
    sellerBadgeText = "Pagamento in verifica";
  } else if (sellerStatus === "OFFERTA_INVIATA") {
    sellerBadgeClass = "is-sent";
    sellerBadgeTone = "success";
  }

  return (
    <MarketplaceListCard
      className="seller-request-card"
      code={richiesta.codice}
      title={getRequestDisplayTitle(richiesta)}
      headerBadges={
        <>
          <StatusBadge tone="info" className="seller-request-card__status">
            {isExpired ? "SCADUTA" : richiesta.stato}
          </StatusBadge>
          <StatusBadge tone={sellerBadgeTone} className={`seller-request-card__seller-status ${sellerBadgeClass}`}>
            {sellerBadgeText}
          </StatusBadge>
        </>
      }
      metaItems={[
        { icon: "fa-shopping-basket", text: `${prodottiCount} prodotti` },
        { icon: "fa-truck", text: modalita },
        { icon: "fa-clock-o", text: formatDateTime(richiesta.createdAt) },
        ...(expiryMetaText
          ? [{ icon: "fa-hourglass-end", text: expiryMetaText, className: "marketplace-list-card__meta-item--danger" }]
          : []),
      ]}
      note={richiesta.noteUtente}
      items={
        prodottiCount > 0
          ? richiesta.prodotti.map((prodotto) => ({
              label: prodotto.nome,
              value: `x${prodotto.quantita}`,
            }))
          : []
      }
      actions={
        <PrimaryActionLink to={requestPath} className="seller-request-card__cta">
          Apri dettaglio
        </PrimaryActionLink>
      }
    />
  );
};

export default SellerRequestCard;





